import React from 'react';
import classNames from 'classnames';

export interface SideNavLinkProps {
  children: string;
  href?: string;
  current?: boolean;
  className?: string;
}

const SideNavLink = ({ children, href, current = false, className }: SideNavLinkProps): JSX.Element => (
  <a href={href} className={classNames({ 'usa-current': current }, className)}>
    {children}
  </a>
);

export default SideNavLink;
